import React from 'react';
import './Privacidad.css';

const Privacidad = () => {
  return (
    <div className="privacidad-container">
      <h1>Politica de seguridad y privacidad</h1>
      <p>Última actualización: 10/10/2025</p>
      
      <h2>1. Compromiso con la Seguridad de la Información</h2>
      <p>
        DS CYBER a través de sus colaboradores se compromete a la protección y resguardo de la información propia, sus clientes y proveedores a través de la cultura y controles que fortalezcan la integridad, disponibilidad o confidencialidad de la información.
      </p>

      <h2>2 Responsable del Tratamiento</h2>
      <p>
        DS CYBER, con domicilio fiscal en Ginebra 46, Vista Marquez, San Andrés Cholula. CP 72826 Puebla, es responsable del tratamiento de sus datos personales conforme a lo dispuesto por la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (México), la Ley de Protección de Datos Personales (Venezuela) y las normas internacionales ISO/IEC 27001 y 27701.
      </p>
      
      <h2>3 Finalidades del Tratamiento</h2>
      <p>Sus datos personales serán utilizados para:</p>
      <ul>
        <li>Cumplir obligaciones contractuales y legales.</li>
        <li>Proveer los servicios y productos solicitados.</li>
        <li>Mejorar la calidad y seguridad de nuestros procesos.</li>
        <li>Enviar información comercial (previo consentimiento).</li>
        <li>Cumplir con políticas de seguridad de la información conforme a ISO 27001.</li>
      </ul>
      
      <h2>4 Datos Personales Recabados</h2>
      <p>
        Podemos recabar datos como: nombre, identificación oficial, dirección, correo electrónico, teléfono, información financiera y cualquier otro necesario para las finalidades descritas.
      </p>
      
      <h2>5 Medidas de Seguridad</h2>
      <p>
       Implementamos controles administrativos, técnicos y físicos conforme a ISO 27001 para garantizar la confidencialidad, integridad y disponibilidad de sus datos personales.
      </p>
      
      <h2>6 Transferencias</h2>
      <p>
        Sus datos podrán ser compartidos con terceros nacionales o internacionales que apoyen en la prestación de servicios, siempre bajo cláusulas contractuales que aseguren el cumplimiento de las leyes aplicables y estándares ISO.
      </p>
      
      <h2>7 Derechos ARCO</h2>
      <p>Usted puede ejercer sus derechos de:</p>
      <ul>
        <li>Acceso: Conocer qué datos tenemos y cómo los usamos.</li>
        <li>Rectificación: Solicitar corrección de datos inexactos.</li>
        <li>Cancelación: Pedir la eliminación de sus datos cuando proceda.</li>
        <li>Oposición: Negarse al tratamiento para fines específicos.</li>
      </ul>
      <p>Para ejercer estos derechos, envíe su solicitud a:<br />
        Correo: gestion@dscyber.io<br />
        Teléfono: +52 222.688.16.93 Ext 109
      </p>
      
      <h2>8 Revocación del Consentimiento</h2>
      <p>
       Puede revocar su consentimiento en cualquier momento mediante solicitud escrita al correo indicado.
      </p>

      <h2>9 Cambios al Aviso</h2>
      <p>
       Cualquier modificación será publicada en www.dscyber.io/privacidad.
      </p>

      <h2>10 Base Legal</h2>
      <p>Este aviso se emite conforme a:</p>
      <ul>
        <li>México: LFPDPPP y su Reglamento.</li>
        <li>Venezuela: Ley de Protección de Datos Personales.</li>
        <li>ISO/IEC 27001 y 27701: Gestión de seguridad y privacidad.</li>
      </ul>
    </div>
  );
};

export default Privacidad;

